var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"timer"},[_c('span',{},[_vm._v("残り時間 ")]),(!_vm.isEnd && !_vm.$store.state.isRe)?_c('span',{},[_vm._v(_vm._s(_vm.timerStr))]):_c('span',{},[_vm._v("ー")])])
}
var staticRenderFns = []

export { render, staticRenderFns }